type HistoryFields = Record<string, string>;

export const historyFields: HistoryFields = {
  IdRoadmapVersion: 'Version',
  Item: 'Item',
};
